/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsItemSchema } from '../models/NewsItemSchema';
import type { NewsListSchema } from '../models/NewsListSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NewsApi {
    /**
     * Get News Item
     * Get news item.
     * @returns NewsItemSchema OK
     * @throws ApiError
     */
    public static newsGetNewsItemGet({
        newsItemSlug,
    }: {
        newsItemSlug: string,
    }): CancelablePromise<NewsItemSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/news/{news_item_slug}/',
            path: {
                'news_item_slug': newsItemSlug,
            },
        });
    }
    /**
     * Get News List
     * Get list of news items.
     * @returns NewsListSchema OK
     * @throws ApiError
     */
    public static newsGetNewsListGet(): CancelablePromise<NewsListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/news/',
        });
    }
}
